import {Component, Inject, OnInit} from '@angular/core';
import {
    CatalogosService,
    ConficuracionDocumentosModel,
    FiltroPaginadorDocumentosModel,
    LlaveNegocioModel
} from "@evomatik/evk-content";
import {EvkSecurityControlDataService} from "@evomatik/evk-seguridad";
import {BusinessDataService} from "@evomatik/evk-forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'lib-contenedor-adjuntar',
    templateUrl: './contenedor-adjuntar.component.html',
    styleUrls: ['./contenedor-adjuntar.component.css']
})
export class ContenedorAdjuntarComponent implements OnInit {

    configuracionDocumentos: ConficuracionDocumentosModel;
    idExpediente: string;
    uuid: string;

    constructor(
        public dialogRef: MatDialogRef<ContenedorAdjuntarComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private evkSecurity: EvkSecurityControlDataService,
        private catalogoService: CatalogosService,
        private businessDataService: BusinessDataService
    ) {
        if (data) {
            this.uuid = data.uuid;
        }
    }

    ngOnInit(): void {
        this.configuracionDocumentos = new ConficuracionDocumentosModel();
        if (this.evkSecurity.getUsuarioInfo().cargo != undefined && this.evkSecurity.getUsuarioInfo() != undefined) {
            this.configuracionDocumentos.puesto = this.evkSecurity.getUsuarioInfo().cargo;
        } else {
            this.configuracionDocumentos.puesto = '';
        }
        this.configuracionDocumentos.usuario = this.evkSecurity.getUsuarioInfo().nombreCompleto;
        this.configuracionDocumentos.nombre = this.evkSecurity.getUsuarioInfo().username;
        this.configuracionDocumentos.relativePath = this.getRelativePath();
        this.configuracionDocumentos.canAdd = true;
        this.configuracionDocumentos.canEdit = true;
        this.configuracionDocumentos.canView = true;
        this.configuracionDocumentos.llavesNegocio = [];
        this.configuracionDocumentos.llavesNegocio.push(this.creaLlaveNegocio('idIndicio', this.uuid));
        this.configuracionDocumentos.filtro = new FiltroPaginadorDocumentosModel();
        this.configuracionDocumentos.showDescargaZip = true;
        this.configuracionDocumentos.filtro.llavesNegocio = JSON.stringify([this.creaLlaveNegocio('idIndicio', this.uuid)]);
        this.configuracionDocumentos.filtro.allAdjunto = true;
        this.configuracionDocumentos.filtro.allGenerado = false;
        this.catalogoService.getByDiscriminator('TIPO-DE-DOCUMENTO-DESAPARECIDAS')
            .subscribe(respuesta => {
                this.configuracionDocumentos.tiposDocumento = respuesta;
            });
        this.catalogoService.getByDiscriminator('TIPO-FOTOGRAFIA')
            .subscribe(respuesta => {
                this.configuracionDocumentos.tiposFotografia = respuesta;
            });
    }

    getRelativePath(): string {
        const id = this.businessDataService.getValue('idExpediente');
        return `Expedientes/${id}/Indicios`;
    }

    creaLlaveNegocio(key: string, valor: any): LlaveNegocioModel {
        const llave = new LlaveNegocioModel();
        llave.llave = key;
        llave.valor = valor;
        return llave;
    }

}
